var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "div",
      { staticClass: "table-common" },
      [
        _c("a-table", {
          attrs: {
            size: "middle",
            columns: _vm.confirmColumns,
            "row-key": function(record) {
              return record.id
            },
            "data-source": _vm.tableData,
            pagination: _vm.pagination,
            loading: _vm.loading,
            bordered: "",
            locale: { emptyText: "暂无数据" }
          },
          scopedSlots: _vm._u([
            {
              key: "rcvpymtInt",
              fn: function(text, record) {
                return [
                  _vm._v(
                    _vm._s(
                      record.rcvpymtInt
                        ? _vm.utils.splitK(record.rcvpymtAmt) +
                            "+" +
                            _vm.utils.splitK(record.rcvpymtInt)
                        : _vm.utils.splitK(record.rcvpymtAmt)
                    )
                  )
                ]
              }
            }
          ])
        })
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-e7fbed3c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e7fbed3c","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/bill-payment/record-detail-modal.vue
// module id = hNNz
// module chunks = 1